import firebase from "firebase";
import instance from "../../services/axios";
import api from "../../services/Api";

export const handlefacebook = async () => {
  var retorno;
  const providerface = new firebase.auth.FacebookAuthProvider();
  await firebase
    .auth()
    .signInWithPopup(providerface)
    .then(async (result) => {
      const token = result.user._lat;
      instance.defaults.headers.Authorization = token;
      if (result.additionalUserInfo.isNewUser === true) {
        const cpf = undefined;
        const nomeCompleto = result.additionalUserInfo.profile.name;
        const genero = result.additionalUserInfo.profile.gender;
        const id = result.additionalUserInfo.profile.id;
        const validateEmail = result.additionalUserInfo.profile.verified;
        const email = result.additionalUserInfo.profile.email;
        const foto = result.additionalUserInfo.profile.picture.data.url;
        const local = result.additionalUserInfo.profile.locale;
        const linkProfile = result.additionalUserInfo.profile.link;
        const uid = result.user.uid;

        const NewUser = {
          id_facebook: id,
          nome: nomeCompleto,
          genero: genero,
          validateEmail: validateEmail,
          email: email,
          foto: foto,
          local: local,
          linkProfile,
          uid: uid,
          cpf: cpf,
        };
        await api.saveUser(NewUser).then((user) => {
          retorno = user;
        });
      } else {
        retorno = result;
      }
    })
    .catch((err) => {
      retorno = err;
    });
  return retorno;
};



// WEBPACK FOOTER //
// ./src/assets/js/loginFacebook.js